export const environment = {
	production: false,
	api: 'https://dev-revealense-api.revealense.com/api/V1/',
	external_api: 'https://dev-api.revealense.com/api/V1'
};
